import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';

import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {ConfigService} from '../services/config.service';
import {EventsEmitterService} from '../services/emitter.service';
import {LogService} from '../services/log.service';
import {SecurityService} from '../services/security.service';

@Injectable()
export class MenuService extends SecurityService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger);
  }

  getMenusForUser(langId: string): Observable<any> {
    let serviceUrl = this.baseUrl + 'MenuService/menuByPerId?' + 'langId=' + langId;
    return this.request(serviceUrl).pipe(
      map((response) => {
        // let body = this.parseMenus(response.json(),auth_rev == 'Y');
        let body = response;
        localStorage.setItem('menusArray_' + langId, JSON.stringify(body));
        return body;
      }),
      catchError(super.handleError),
    );
  }
}
